export const $ApiMessagesModuleName = "apiMessages";

type TApiMessages = {
    general: any[];
    products: any[];
};

export type TApiMessagesState = {
    data: null | TApiMessages;
};
